import ApiService from './api.service';

class ClientService {
  async list({ page = 1, limit = 10, search = '' } = {}) {
    try {
      const query = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search: search || '',
      });
      const response = await ApiService.get(`/clients?${query.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ClientService();
